<canvas #canvas class="mask"></canvas>